import React from 'react';

const FormNotFoundErrorModalBody = () => {
  return <div>Form not found</div>;
};

export default FormNotFoundErrorModalBody;
